"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
const ProductAttributes = __importStar(require("./ProductAttributes"));
const IAParameters = __importStar(require("./IAParameters"));
const Meta = __importStar(require("./Meta"));
exports.Type = prelude_1.t.strict({
    productId: prelude_1.t.number,
    image: prelude_1.t.NonEmptyString,
    gallery: prelude_1.t.readonlyArray(prelude_1.t.type({ original: prelude_1.t.NonEmptyString, thumbnail: prelude_1.t.NonEmptyString })),
    name: prelude_1.t.NonEmptyString,
    description: prelude_1.t.string,
    attributes: ProductAttributes.Type,
    parameters: IAParameters.Type,
    meta: Meta.WAPFProduct.Type
});
//# sourceMappingURL=Product.js.map